fx.ns("models", class ThemeLayout extends fx.Model {

	constructor(data)
	{
		super(data);
	}
	
    get localized()
    {
        return true;
    }

	get defaults()
	{
		return {
			page_id : 0,
        	bgcolor : "rgba(0,0,0,0)",
        	components : [],
			num_photos : 0,
			num_texts : 0,
			height : 0,
			width : 0,
			themeid : -1,
			visible : 0,
			thumb : "",
            target : ""
		}
	}

	get propertiesNotStorable()
    {
        return ["thumb", "id"];
    }
    
    /**
     * Basic layouts have themeid equal to -1
     */
    get isBasic()
    {
        return this.themeid == -1 && this.accountid == 0 && this.product_id == 0;
    }

    get isPoster()
    {
        return  this.product_type_id == models.ProductType.POSTER;
    }

    get isCalendar()
    {
        return  this.shape == "wall-double" ||
                this.shape == "wall-single" ||
                this.shape == "desk" ;
    }

    get sortedComponents()
    {
        return this.components.sort(this._componentsSort);
    }

    get hasFilteredPhoto()
    {
        //return this.posterPage.getPhotos().find({content_type : "remove-background"});
        let photos = this.getPhotos();

        for(let i = 0; i < photos.length; i++)
        {
            let photo = photos.getItemAt(i);
            if (photo.content_type != "")
                return !!photo;
        }
    }


    getComponent(id) {
        return this.components.find({ id: id });
    }


    _componentsSort(a, b) 
    {  
        if (a.content_type == "slice-text")
            return 1;
        else
        if (b.content_type == "slice-text")
            return -1;

        if (a.isBackground && !b.isBackground)
            return -1;

        if (!a.isBackground && b.isBackground)
            return 1;

        if (a.isBackground && b.isBackground)
        {
            if (a.creation == "slice")
                return 1;
            else
            if (b.creation == "slice")
                return -1;
            else
                return 0;
        }

        if (a.isSliceText)
        {
            if (b.isBackground)
                return 1;
            else
                return -1;
        }

        if (a.level < b.level)
            return -1;

        if (a.level > b.level)
            return 1;

        return 0;
    }
	
	getBackground(side)
    {
        let bg;
        for(let i = 0; i < this.components.length; i++)
        {
            let component = this.components.getItemAt(i);
            if (!component._deleted && component.isBackground && (!side || component.creation == side))
            {
                bg = component;
                break;
            }
        }
        return bg;
    }

    getBackgrounds()
    {
        let bgs = [];
        for(let i = 0; i < this.components.length; i++)
        {
            let component = this.components.getItemAt(i);
            if (!component._deleted && component.isBackground)
                bgs.push(  component );
            
        }
        return bgs;
    }


    getStickers()
    {
        let stickers = [];
        for(let i = 0; i < this.components.length; i++)
        {
            let component = this.components.getItemAt(i);
            if (!component._deleted && component.isSticker)
                stickers.push(  component );
            
        }
        return stickers;
    }

    getPhotos()
    {
        let photos = [];
        for(let i = 0; i < this.components.length; i++)
        {
            let component = this.components.getItemAt(i);
            if (!component._deleted && component.isPhoto)
                photos.push(  component );
            
        }
        return photos;
    }

    duplicate()
    {
        let layout = new models.ThemeLayout(this.JSON());

       
        layout.components.removeAll();

        for (let i = 0; i < this.components.length; i++)
        {
            let json = this.components.getItemAt(i).JSON();
            json.theme_layout_id = layout.id;
            delete(json.id);
            delete(json.creation_element_id);
            layout.components.addItem( new models.ThemeLayoutComponent( json ) );
        }

        return layout;
    }

    addComponent(data)
    {
        delete(data.id);

        if (data.component_type == "background")
        {
            let backgrounds = this.getBackgrounds();
            if (backgrounds.length == 0)
            {
                this.addBackground(data.side);
                backgrounds = this.getBackgrounds();
            }

            if (backgrounds.length > 0)
            {
                let background = backgrounds.getItemAt(0);
                background.content = data.content;
                background.bgcolor = data.bgcolor;

                return;
            }
            
        }

        let index = this.components.length;

        let component = new models.ThemeLayoutComponent(data)
        component.level = index + 1;

        for (let i = index + 1; i < this.components.length; i++)
            this.components.getItemAt(i).level++;

        this.components.addItemAt( index + 1, component );
    }

    updateBackgroundColor(color, removeContent)
    {
        let bg = this.getBackground();

        if (!bg)
            bg = this.addBackground()

        if (bg)
            bg.update({ content: removeContent ? "" : bg.content, bgcolor: color });

        this.bgcolor = color;
    }

    addBackground(side) {
        let background = this.getBackground(side);

        if (!background)
        {
            background = new models.CreationElementContent({ creation_element_id: this.id, creation: side, component_type: "background", bgcolor: this.bgcolorleft, align: "" })
            this.components.addItemAt(0, background);
        }

        return background;
    }


   // ------------------------- //
    saveLayoutThumb(element, creation)
    {
        this.on("thumb-generated", this._onLayoutThumbReady, fx.service("LayoutThumbGenerator"));

        fx.service("LayoutThumbGenerator").generate(element, creation);
    }

    _onLayoutThumbReady(event)
    {
        this.off("thumb-generated", this._onLayoutThumbReady, fx.service("LayoutThumbGenerator"));

        let thumb = event.detail.thumb;
        
        this.post("/app/layouts/", {
                                        action : "savethumbbacislayouts", 
                                        layoutid : this.id,
                                        thumb : thumb,
                                        width : this.width * event.detail.ratio,
                                        height : this.height * event.detail.ratio
                                    },  this._savedLayoutThumb );
    }

    _savedLayoutThumb(data)
    {
        if (data.error)
        {
            this.event("save-layout-error");
        }
        else
        {
            this.thumb = data.thumb;
            this.event("layout-thumb-saved");
        }
    }



    removeSticker(id)
    {
        let stickers = this.getStickers();
        for(let i = 0; i < stickers.length; i++)
        {
            if (stickers[i].content == id)
                stickers[i].delete();
        }
    }

    removeBackground(id)
    {
        let backgrounds = this.getBackgrounds();
        for(let i = 0; i < backgrounds.length; i++)
        {
            if (backgrounds[i].content == id)
                backgrounds[i].delete();
        }
    }


    onUpdated(action) 
    {
        if (action.tag == "update-level-up")
            this.updateLevels(action.model, false);

        if (action.tag == "update-level-down")
            this.updateLevels(action.model, true);
    }

    updateLevels(component, down) {
        if (down)
            this.components.moveItem(component, this.getBackgrounds().length);
        else
            this.components.moveItem(component, this.components.length - 1);

        for (let i = 0; i < this.components.length; i++)
            this.components.getItemAt(i).level = i;
    }

    
});